import { BottomSheet } from '../components/BottomSheet';
import { useEditor } from './EditorContext';
import type { SpacingProfile } from '../types/agenda';

const PROFILES: SpacingProfile[] = ['compact', 'medium', 'loose'];

// Edit agenda-level metadata. Mirrors fields from the new-agenda flow.
export function DetailsSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { draft, setMeta } = useEditor();
  const isGeneral = draft.meetingType === 'general';

  return (
    <BottomSheet open={open} onClose={onClose} title="Agenda details">
      <div className="details-form">
        <label className="field">
          <span className="field-label">Title</span>
          <input
            className="input"
            value={draft.title}
            onChange={(e) => setMeta({ title: e.target.value })}
          />
        </label>

        <div className="field-row">
          <label className="field">
            <span className="field-label">Date</span>
            <input
              className="input"
              type="date"
              value={draft.date}
              onChange={(e) => setMeta({ date: e.target.value })}
            />
          </label>
          {isGeneral && (
            <label className="field">
              <span className="field-label">Meeting time</span>
              <input
                className="input"
                placeholder="7:00"
                value={draft.meetingTime ?? ''}
                onChange={(e) => setMeta({ meetingTime: e.target.value })}
              />
            </label>
          )}
        </div>

        <label className="field">
          <span className="field-label">Location</span>
          <input
            className="input"
            value={draft.location ?? ''}
            onChange={(e) => setMeta({ location: e.target.value })}
          />
        </label>

        {isGeneral && (
          <div className="field-row">
            <label className="field">
              <span className="field-label">Organization</span>
              <input
                className="input"
                value={draft.organization ?? ''}
                onChange={(e) => setMeta({ organization: e.target.value })}
              />
            </label>
            <label className="field">
              <span className="field-label">Series</span>
              <input
                className="input"
                value={draft.series ?? ''}
                onChange={(e) => setMeta({ series: e.target.value })}
              />
            </label>
          </div>
        )}

        <label className="field">
          <span className="field-label">PDF spacing</span>
          <div className="segmented">
            {PROFILES.map((p) => (
              <button
                key={p}
                className={`segment${(draft.spacingProfile ?? 'medium') === p ? ' active' : ''}`}
                onClick={() => setMeta({ spacingProfile: p })}
              >
                {p.charAt(0).toUpperCase() + p.slice(1)}
              </button>
            ))}
          </div>
        </label>

        <button className="btn btn-primary btn-block" onClick={onClose}>
          Done
        </button>
      </div>
    </BottomSheet>
  );
}
